import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { closeDataRequestMutation } from "./data-request.gql";

interface CloseDataRequestResponse {
  closeDataRequest: { id: string; status: string };
}

interface UseCloseDataRequestProps {
  onCompleted?: () => void;
  onError?: () => void;
}

export function useCloseDataRequestMutation({ onCompleted, onError }: UseCloseDataRequestProps = {}) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: { id: string; workspaceId: string }) => {
      const client = createOperationClient("CloseDataRequest");
      const data = await client.request<CloseDataRequestResponse>(closeDataRequestMutation, params);
      return data.closeDataRequest;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.dataRequests.all });
      onCompleted?.();
    },
    onError: () => {
      onError?.();
    },
  });

  return {
    closeDataRequest: mutation.mutate,
    loading: mutation.isPending,
  };
}
